import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ApolloProvider } from "@apollo/react-hooks";
import _ from "lodash";
import "bootstrap/dist/css/bootstrap.css";
import fetch from "isomorphic-unfetch";

import { Provider } from "react-redux";
import createStore from "../../lib/store";
import "./index.less";

import Audio from "../../components/Audio";
import apollo from "../../lib/apollo";
import PageContainer from "./../PageContainer";
import IntroAnimation from "../../components/IntroAnimation/index";
import withTagmanager from "../_hocs/withTagmanager";

import routeList from "./../../config/routeList.json";

// Polyfill fetch() on the server (used by apollo-client)
if (typeof window === "undefined") {
  global.fetch = fetch;
}

const App = () => {
  const store = createStore();

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Audio>
          <Route
            render={props => {
              const { location } = props;
              const indexedRoutes = _.keyBy(routeList, "path");
              const { pathname } = location || {};

              return (
                <>
                  <Switch location={location}>
                    <ApolloProvider client={apollo()}>
                      <IntroAnimation {...indexedRoutes[pathname]} />
                      <PageContainer />
                    </ApolloProvider>
                  </Switch>
                </>
              );
            }}
          />
        </Audio>
      </BrowserRouter>
    </Provider>
  );
};

export default withTagmanager(App);
